<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-icon-wrap">
      <mat-icon>drive_file_rename_outline</mat-icon>
    </div>
    <div class="header-text">
      <h2>Rename Project</h2>
      <p>Update the display name for this project.</p>
    </div>
  </div>

  <div class="dialog-body">
    <div class="error-banner" *ngIf="errorMessage">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <div class="form-group">
      <label for="renameProjectInput">Project Name <span class="required">*</span></label>
      <input
        id="renameProjectInput"
        type="text"
        class="form-control"
        placeholder="e.g. Phoenix Portal, Mobile App v2"
        [(ngModel)]="projectName"
        (keydown.enter)="onSubmit()"
        maxlength="80"
        autofocus
      />
      <span class="field-hint">Must be at least 2 characters.</span>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-button type="button" (click)="onCancel()" [disabled]="isSubmitting">
      Cancel
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="onSubmit()"
      [disabled]="!isValid || isSubmitting"
    >
      <mat-icon *ngIf="!isSubmitting">check</mat-icon>
      <span *ngIf="!isSubmitting">Save Name</span>
      <span *ngIf="isSubmitting">Saving...</span>
    </button>
  </div>
</div>
